// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"40815ce0","453":"da45a303","455":"80c9fcd3","884":"c849cd61","977":"bd801e9c"}[chunkId] + ".chunk.js";
};